export default [
  {
    title: 'breadcrumb.vvipReport',
    children: [
      {
        title: 'breadcrumb.balanceReport',
        route: 'vvip-report',
        icon: '',
        resource: 'balance-report-vvip',
        action: 'read',
      },
      {
        title: 'breadcrumb.paybackCommissionReport',
        route: 'vvip-report-payback-commission',
        icon: '',
        resource: 'balance-report-vvip',
        action: 'read',
      },
      {
        title: 'breadcrumb.cockBalanceReport',
        route: 'vvip-report-sabong',
        icon: '',
        resource: 'balance-report-vvip',
        action: 'read',
      },
      {
        title: 'breadcrumb.baccaratBalanceReport',
        route: 'vvip-report-baccarat',
        icon: '',
        resource: 'balance-report-vvip',
        action: 'read',
      },
      {
        title: 'breadcrumb.slotBalanceReport',
        route: 'vvip-report-joker',
        icon: '',
        resource: 'balance-report-vvip',
        action: 'read',
      },
      {
        title: 'breadcrumb.lottoBalanceReport',
        route: 'vvip-report-lotto',
        icon: '',
        resource: 'balance-report-vvip',
        action: 'read',
      },
      {
        title: 'breadcrumb.lotto12BalanceReport',
        route: 'vvip-report-lotto12',
        icon: '',
        resource: 'balance-report-vvip',
        action: 'read',
      },
      {
        title: 'breadcrumb.lotteryBalanceReport',
        route: 'vvip-report-lottery',
        icon: '',
        resource: 'balance-report-vvip',
        action: 'read',
      },
      {
        title: 'breadcrumb.balanceReportSport99',
        route: 'vvip-report-sport99',
        icon: '',
        resource: 'balance-report-vvip',
        action: 'read',
      },
      {
        title: 'breadcrumb.parleyReport',
        route: 'vvip-report-parley',
        icon: '',
        resource: 'balance-report-vvip',
        action: 'read',
      },
    ],
  },
]
